import { render, staticRenderFns } from "./AddDistributorDataDialog.vue?vue&type=template&id=e9fe3bdc&scoped=true"
import script from "./AddDistributorDataDialog.vue?vue&type=script&lang=ts"
export * from "./AddDistributorDataDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddDistributorDataDialog.vue?vue&type=style&index=0&id=e9fe3bdc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fe3bdc",
  null
  
)

export default component.exports